import { Component } from 'react'
import BaseViewModel from './BaseViewModel';
import { BaseResponse, ErrorType, ErrorMessage } from './BaseResponse';
 
 
import BaseComponentCore from './BaseComponentCore';
import BasePageProps from './BasePageProps';
import ConstantMessage from './ConstantMessage';
 
 

export default abstract class BaseComponent<T extends BasePageProps, U> extends BaseComponentCore<T, U> {

  // constructor(props: T) {
  //   super(props)

  // }
  ShowPageLoader(IsLoading: boolean, LabelText: string = "") {
    var model = this.state.Model as unknown as BaseViewModel;
    model.IsPageLoading = IsLoading;
    model.PageLoadingLabel = LabelText ? model.TableLoadingLabel : LabelText;
    this.UpdateViewModelUnknown(model);
  }

  ShowTableLoader(IsLoading: boolean, LabelText: string = "") {
    var model = this.state.Model as unknown as BaseViewModel;
    model.IsTableLoading = IsLoading;
    model.TableLoadingLabel = LabelText ? model.TableLoadingLabel : LabelText;
    this.UpdateViewModelUnknown(model);
  }



  // #region Toast message
  public ProcessResponseData(Response: BaseResponse, ShowIsSucessMessage: boolean = true) {

    if (Response.IsSessionExpired) {
      //TODO:when redux is rady redirect to login automaticaly
      //belowis not working need redux to handle this, so for now we ares showing a message only
      //this.props.history.push("/");
      //return;
      //if (!ShowIsSucessMessage) {
      this.ShowToastMesage("Your session is expired, please try to re-login", ErrorType.Error)
      //}

      //TODO:After new theme migration open
      this.props?.history?.push(ConstantMessage.LoginPagePath);
      return;
    }


    if (!ShowIsSucessMessage && Response.IsSuccess) {
      return;
    }

    var allMessages: ErrorMessage[] = [];
    var mainMesageType = Response.IsSuccess ? ErrorType.Info : ErrorType.Warning;
    allMessages.push(new ErrorMessage(
      {
        ErrorType: mainMesageType,
        Message: Response.Message,
        AdditionInfo: undefined,
        FieldName: ""
      }))

    Response.Errors.forEach(err => {
      allMessages.push(new ErrorMessage(
        {
          ErrorType: err.ErrorType,
          Message: err.Message,
          AdditionInfo: err.AdditionInfo,
          FieldName: err.FieldName
        }))
    });

    this.UpdateModelForToastMessage(allMessages);
  }

  private UpdateModelForToastMessage(AllMesages: ErrorMessage[] | ErrorMessage) {
    var tempArray: ErrorMessage[] = [];

    if (!Array.isArray(AllMesages)) {
      tempArray.push(AllMesages)
    }
    else {
      tempArray = AllMesages;
    }
    var model = this.state.Model as unknown as BaseViewModel;
    model.Messages = tempArray;
    this.UpdateViewModelUnknown(model);
  }

  public ShowToastMesage(Message: string, ErrorType: ErrorType) {
    var message = new ErrorMessage(
      {
        ErrorType: ErrorType,
        Message: Message,
        AdditionInfo: null,
        FieldName: ""
      })
    this.UpdateModelForToastMessage(message)
  }

  public OnToastEntered = (e: any, reason: any, key: string) => {
    //alert('this is obsolate now')
    var model = this.state.Model as unknown as BaseViewModel;
    model.OnToastEntered(e, reason, key)
  }
  // #endregion
 
}

